import React from 'react';
import Link from 'gatsby-link';
import Content, { HTMLContent } from './Content';

export default ({ caseStudies }) => (
  <div>
    { caseStudies.map((caseStudy, index) => (
        <div key={"case-study-" + index}>
            <section id={caseStudy.node.frontmatter.path} className="hero is-sjs-dark-blue">
                <div className="hero-body">
                <div className="container">
                    <h2 className="title">
                        Case Study: {caseStudy.node.frontmatter.title}
                    </h2>
                </div>
                </div>
            </section>
            <section className="section">
                <div className="container content">
                <div className="columns">
                    <div className="column is-10 is-offset-1">
                        <HTMLContent content={caseStudy.node.html} />
                    </div>
                </div>
                </div>
            </section>
        </div>
    ))}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/CaseStudiesSection.js